<template>
  <!-- security: security,  -->
  <div class="footer" :class="{ isKeyPal: isKeyPal, security: security }">
    <div class="content d-flex jc-between">
      <div class="follow-wrap left">
        <img class="logo" :src="logoImg" @click="goHome" />
        <div class="language-btn" @click.stop="showLanguage = !showLanguage">
          <img class="language-img" :src="languageImg" alt="" />
          <span>{{ langLabel }}</span>
          <img class="drop-down" :src="dropDownImg" alt="" />
          <LanguageBox v-if="showLanguage" :langData="langData" />
        </div>
        <div class="designed">
          <div class="sign" v-html="designedHtml"></div>
        </div>
        <div>
          <div class="footer-follows d-flex">
            <a
              href="mailto:support@keypal.pro"
              class="footer-follow"
              :class="[security ? 'security-1' : 'footer-follow-1']"
              target="_blank"
            ></a>
            <div
              class="footer-follow"
              v-for="(item, index) in followList"
              :key="index"
              :class="[security ? 'security-' + (index + 2) : item.class]"
              @click="openFollow(item)"
            ></div>
          </div>
          <div class="copyright" :class="{ security: security }">
            Copyright © 2026 KeyPal, Inc. All rights reserved.
          </div>
        </div>
      </div>
      <!-- d-flex flex-wrap jc-between -->
      <div class="footer-wrap flex-1">
        <div
          v-for="(item, index) in footerList"
          :key="index"
          class="footer-list"
        >
          <div
            class="title"
            :class="{ security: security }"
            @click="onFold(item.type)"
          >
            <span>{{ item.title }}</span>
            <img v-if="footerNavItemMap[item.type]" :src="unFoldImg" alt="" />
            <img v-else :src="foldImg" alt="" />
          </div>

          <div class="footer-link-wrap" v-if="footerNavItemMap[item.type]">
            <div
              class="footer-link"
              v-for="(data, dataIndex) in item.data"
              :key="dataIndex"
            >
              <a
                class="pointer"
                :class="{ security: security }"
                :href="data.url ? data.url : 'javascript:void(0)'"
                :target="data.local ? '_self' : '_blank'"
                @click.stop="onFooterLink(data)"
                >{{ data.title }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="coming-soon" v-show="isComingSoon">
      {{ $t('common.comingSoon') }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LanguageBox from '../common/LanguageBox.vue';
export default {
  props: {
    security: {
      type: Boolean,
    },
    isKeyPal: {
      type: Boolean,
    },
  },
  components: {
    LanguageBox,
  },
  data() {
    return {
      showLanguage: false,
      footerNavItemMap: {
        product: true,
        cryptoAssets: true,
        getStarted: true,
        support: true,
        download: true,
        legal: true,
      },
      isComingSoon: false,
    };
  },
  computed: {
    ...mapGetters(['isMobileSize']),
    designedHtml() {
      // return this.$t('navigation.designed');
      return this.$route.path === '/keypalplus'
        ? this.$t('navigation.designedDark')
        : this.$t('navigation.designed');
    },
    logoImg() {
      if (this.security) {
        return require('../../assets/images/home/logo-dark.png');
      } else {
        return require(`../../assets/images/home/logo${this.darkModeImg}.png`);
      }
    },
    languageImg() {
      return require(`../../assets/images/header/language${this.darkModeImg}.png`);
    },
    dropDownImg() {
      return require(`../../assets/images/footer/drop-down${this.darkModeImg}.png`);
    },
    langData() {
      return {
        title: this.$t('common.language'),
        lang: true,
        child: [
          { label: 'English', lang: 'en' },
          { label: '中文(简体)', lang: 'zh' },
          { label: '中文(繁体)', lang: 'zh-tw' },
          { label: '日本語', lang: 'ja' },
          { label: '한국어', lang: 'ko' },
          { label: 'Français', lang: 'fr' },
          { label: 'Español', lang: 'es' },
        ],
      };
    },
    langLabel() {
      let lang = this.$i18n.locale;
      switch (lang) {
        case 'zh':
          return '中文(简体)';
        case 'zh-tw':
          return '中文(繁体)';
        case 'en':
          return 'English';
        case 'ja':
          return '日本語';
        case 'ko':
          return '한국어';
        case 'fr':
          return 'Français';
        case 'es':
          return 'Español';
        default:
          return '中文(简体)';
      }
    },
    followList() {
      return [
        { url: 'https://github.com/KeyPalWallet', class: 'footer-follow-2' },
        { url: 'https://twitter.com/KeypalWallet', class: 'footer-follow-3' },
        { url: 'https://medium.com/@Keypal', class: 'footer-follow-4' },
      ];
    },
    gitBookLangPath() {
      const langMap = {
        zh: 'zh-cn',
        'zh-tw': 'zh-hk',
        en: 'en',
        ja: 'jp',
        ko: 'kr',
        fr: 'fr',
        es: 'es',
      };

      return langMap[this.$i18n.locale] || 'zh-cn';
    },
    gitBookBaseUrl() {
      return `https://keypal.gitbook.io/${this.gitBookLangPath}`;
    },
    footerList() {
      return [
        {
          title: this.$t('navigation.product.title'),
          type: 'product',
          data: [
            {
              title: 'KeyPal 2',
              toTop: true,
              local: true,
            },
            {
              title: 'KeyPal Plus',
              // local: true,
              // routePath: '/keypalplus',
              url: location.origin + '/#/keypalplus',
            },
            {
              title: 'KeyPal Card',
              url: `https://card.keypal.pro`,
            },
            {
              title: this.$t('navigation.product.label_2'),
              // local: true,
              // routePath: '/safebox',
              url: location.origin + '/#/safebox',
            },
          ],
        },
        // {
        //   title: this.$t('navigation.cryptoAssets.title'),
        //   type: 'cryptoAssets',
        //   data: [
        //     {
        //       title: this.$t('navigation.cryptoAssets.label_1'),
        //       url: `https://card.keypal.pro`,
        //     },
        //     {
        //       title: this.$t('navigation.cryptoAssets.label_2'),
        //       url: `https://card.keypal.pro`,
        //     },
        //     {
        //       title: this.$t('navigation.cryptoAssets.label_3'),
        //       url: `https://card.keypal.pro`,
        //     },
        //     {
        //       title: this.$t('navigation.cryptoAssets.label_4'),
        //       url: `https://card.keypal.pro`,
        //     },
        //     {
        //       title: this.$t('navigation.cryptoAssets.label_5'),
        //       url: `https://card.keypal.pro`,
        //     },
        //   ],
        // },
        {
          title: this.$t('navigation.getStarted.title'),
          type: 'getStarted',
          data: [
            // {
            //   title: this.$t('navigation.getStarted.label_1'),
            //   url: `https://card.keypal.pro`,
            // },
            {
              title: this.$t('navigation.getStarted.label_2'),
              url: `${this.gitBookBaseUrl}/user-manual/keypal-2/tutorial`,
            },
            {
              title: this.$t('navigation.getStarted.label_3'),
              url: `https://card.keypal.pro/tutorials`,
            },
            {
              title: this.$t('navigation.getStarted.label_4'),
              url: location.origin + '/#/academy',
            },
            {
              title: this.$t('navigation.getStarted.label_5'),
              url: `https://www.keypal.pro/keypal2/tutorial/#/safebox`,
            },
          ],
        },
        {
          title: this.$t('navigation.support.title'),
          type: 'support',
          data: [
            {
              title: this.$t('navigation.support.label_1'),
              url: this.gitBookBaseUrl,
            },
            {
              title: this.$t('navigation.support.label_3'),
              url: 'https://fans.tokenpocket.pro/',
            },
          ],
        },
        {
          title: this.$t('navigation.download.title'),
          type: 'download',
          data: [
            {
              title: this.$t('navigation.download.label_1'),
              url: `https://tokenpocket.pro/`,
            },
            {
              title: this.$t('navigation.download.label_2'),
              url: `https://extension.tokenpocket.pro/`,
            },
            {
              title: this.$t('navigation.download.label_3'),
              // local: true,
              // routePath: '/firmwareupgrade',
              url: location.origin + '/#/firmwareupgrade',
            },
          ],
        },
        {
          title: this.$t('navigation.legal.title'),
          type: 'legal',
          data: [
            // {
            //   title: this.$t('navigation.others.label_1'),
            //   url:
            //     this.$i18n.locale === 'en'
            //       ? 'https://keypal.gitbook.io/en/about/contact-us'
            //       : 'https://keypal.gitbook.io/zh-cn/about/contact-us',
            // },
            {
              title: this.$t('navigation.others.label_2'),
              url: `${this.gitBookBaseUrl}/product-policy/privacy-policy`,
            },
            {
              title: this.$t('navigation.others.label_3'),
              url: `${this.gitBookBaseUrl}/product-policy/terms-of-use`,
            },
          ],
        },
      ];
    },
    foldImg() {
      return require(`../../assets/images/footer/fold${this.darkModeImg}.png`);
    },
    unFoldImg() {
      return require(`../../assets/images/footer/unfold${this.darkModeImg}.png`);
    },
  },
  watch: {
    isMobileSize: {
      handler(val) {
        if (val) {
          this.footerNavItemMap = {
            product: false,
            cryptoAssets: false,
            getStarted: false,
            support: false,
            download: false,
            legal: false,
          };
        } else {
          this.footerNavItemMap = {
            product: true,
            cryptoAssets: true,
            getStarted: true,
            support: true,
            download: true,
            legal: true,
          };
        }
      },
      immediate: true,
    },
  },
  mounted() {
    document.addEventListener('click', () => {
      this.showLanguage = false;
    });
  },
  methods: {
    onFold(type) {
      if (this.isMobileSize) {
        this.footerNavItemMap[type] = !this.footerNavItemMap[type];
      }
    },
    goHome() {
      if (this.$route.path !== '/') {
        this.$router.push({ path: '/' });
      }
    },
    openFollow(item) {
      if (item.isTelegram) {
        this.url = item.url;
      } else {
        window.open(item.url);
      }
    },
    onFooterLink(data) {
      if (data.lang) {
        this.$i18n.locale = data.lang;
        document.title = this.$t('common.documentTitle');
      } else if (data.routePath) {
        this.$router.push({ path: data.routePath });
      } else if (data.toTop) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      } else if (data.comingSoon) {
        this.isComingSoon = true;
        setTimeout(() => {
          this.isComingSoon = false;
        }, 2000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@for $i from 1 through 4 {
  .footer-follow-#{$i} {
    background: url(../../assets/images/footer/#{$i}.png)
      no-repeat
      100% /
      contain;
    cursor: pointer;
    &:hover {
      background: url(../../assets/images/footer/#{$i}-on.png)
        no-repeat
        100% /
        contain;
    }
  }
}
// background: url(../../assets/images/security/security-#{$i}.png)
@for $i from 1 through 4 {
  .security-#{$i} {
    background: url(../../assets/images/footer/#{$i}.png)
      no-repeat
      100% /
      contain;
    cursor: pointer;
    &:hover {
      background: url(../../assets/images/footer/#{$i}-on.png)
        no-repeat
        100% /
        contain;
    }
  }
}
.footer {
  padding: 90px 0 150px;
  background: var(--bg-1);
  &.security {
    background: #101010;
  }
  &.isKeyPal {
    background: #fff;
  }
  .content {
    .left {
      font-size: 0;
    }
    .follow-wrap {
      .logo {
        width: 111px;
        height: 26px;
        cursor: pointer;
      }
      .language-btn {
        position: relative;
        margin-top: 24px;
        display: flex;
        align-items: center;
        gap: 0 12px;
        height: 45px;
        width: fit-content;
        padding: 0 20px;
        background: var(--bg-6);
        border-radius: 54px;
        cursor: pointer;
        .language-img {
          width: 20px;
          height: 20px;
        }
        .drop-down {
          width: 10px;
          height: 7px;
        }
        span {
          font-size: 14px;
          font-weight: 500;
          color: var(--color-1);
        }
      }
      .designed {
        margin-top: 24px;
        font-size: 12px;
        color: var(--color-3);
      }
      .footer-follows {
        margin: 24px 0;
        display: flex;
        gap: 0 12px;
        .footer-follow {
          width: 32px;
          height: 32px;
        }
      }
      .copyright {
        font-size: 12px;
        font-family: Inter-Regular;
        color: var(--color-3);
        &.security {
          color: rgba(255, 255, 255, 0.4);
        }
      }
    }
    .footer-wrap {
      margin-left: 120px;
      display: grid;
      grid-template-columns: auto auto auto max-content;
      gap: 50px;
      .footer-list {
        padding: 0 10px;
        .title {
          font-size: 14px;
          color: var(--color-3);
          text-align: left;
          line-height: 20px;
          &.security {
            color: #fff;
          }
          img {
            display: none;
          }
        }
        .footer-link-wrap {
          margin-top: 20px;
          display: flex;
          flex-direction: column;
          gap: 16px 0;
          .footer-link {
            display: flex;
            a {
              display: flex;
              font-size: 14px;
              font-weight: 600;
              color: var(--color-1);
              cursor: pointer;
              &.security {
                color: rgba(255, 255, 255, 0.4);
              }
            }
            a:hover {
              color: #2980fe;
            }
          }
        }
      }
    }
  }

  .coming-soon {
    position: fixed;
    left: 50%;
    top: 435px;
    transform: translateX(-50%);
    width: 800px;
    height: 60px;
    background: rgba(0, 0, 0, 0.5);
    border: 1px solid var(--border-2);
    border-radius: 40px;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    color: #ffffff;
    line-height: 60px;
  }
}

@media screen and (max-width: 1200px) {
  .footer {
    .content {
      padding: 0 28px;
      flex-direction: column;

      .footer-wrap {
        margin-left: 0;
        margin-top: 40px;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  @for $i from 1 through 4 {
    .footer-follow-#{$i} {
      background: url(../../assets/images/footer/#{$i}.png)
        no-repeat
        100% /
        contain;
      cursor: pointer;
      &:hover {
        background: url(../../assets/images/footer/#{$i}.png)
          no-repeat
          100% /
          contain;
      }
    }
  }
  @for $i from 1 through 4 {
    .security-#{$i} {
      background: url(../../assets/images/security/security-#{$i}.png)
        no-repeat
        100% /
        contain;
      cursor: pointer;
      &:hover {
        background: url(../../assets/images/security/security-#{$i}.png)
          no-repeat
          100% /
          contain;
      }
    }
  }
  .footer {
    .content {
      padding: 0 28px;
      flex-direction: column;
      .follow-wrap {
        align-items: center;
        .logo {
          width: 119px;
          height: 28px;
        }
        .language-btn {
          display: none;
        }
        .designed {
          margin-top: 32px;
        }
        .footer-follows {
          margin: 20px 0 24px;
          .footer-follow {
            width: 32px;
            height: 32px;
          }
        }
        .copyright {
          font-size: 12px;
        }
      }
      .footer-wrap {
        margin-left: 0;
        margin-top: 32px;
        grid-template-columns: auto;
        gap: 20px 0;
        .footer-list {
          padding: 0;
          .title {
            padding: 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 15px;
            font-weight: 500;
            color: var(--color-1);
            img {
              display: inline-block;
              width: 12px;
              height: 12px;
            }
          }
          .footer-link-wrap {
            margin: 12px 0 0 20px;
            gap: 8px 0;
            .footer-link {
              a {
                font-size: 14px;
                color: var(--color-3);
                font-weight: 400;
              }
              .security:hover {
                color: rgba(255, 255, 255, 0.4);
              }
              a:hover {
                color: var(--color-3);
              }
            }
          }
        }
      }
    }

    .coming-soon {
      width: 80%;
    }
  }
}
</style>
